export default __webpack_public_path__ + "static/media/flag-es-CO.3d5ab99f.png";